const activityCenter = {
  title: 'Centro de actividad',
  noRecentActivity: 'No hay actividad reciente',
  inProgress: 'En progreso',
  recentFiles: 'Archivos recientes',
};

export default { activityCenter };
